import React, { useState } from "react";
import SubMenu from "./SubMenu";
import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { MenuIcon } from "lucide-react";

const MainMenu = () => {
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [activeMenuItem, setActiveMenuItem] = useState(null);
    const [submenuPosition, setSubmenuPosition] = useState(null);

    const [menuItems, setMenuItems] = useState([
        {
            cardData: [
                {
                    data: {
                        itemName: "Home",
                        Icon: HomeIcon,
                        subCategories: null,
                        onTap: { NavigationType: "3",FSN:103, FAI: { link: "/home" } },
                    },
                },
            ],
        },
        {
            cardData: [
                {
                    data: {
                        itemName: "Address",
                        Icon: LocationOnIcon,
                        subCategories: null,
                        onTap: { NavigationType: "3",FSN:120, FAI: { link: "/address" } },
                    },
                },
            ],
        },
        {
            cardData: [
                {
                    data: {
                        itemName: "Order",
                        Icon: ShoppingCartIcon,
                         // Changed to a string
                        subCategories: null,
                        onTap: { NavigationType: "3",FSN: 200, FAI: { link: "/order" } },
                    },
                },
            ],
        },
        {
            cardData: [
                {
                    data: {
                        itemName: "Support",
                        Icon: SupportAgentIcon,
                        subCategories: null,
                        onTap: { NavigationType: "3",FSN:170, FAI: { link: "/fsn170" } },
                    },
                },
            ],
        },
    ]);
    const handleMenuItemClick = (index, event, item) => {
        console.log("Clicked item:", item); // Debugging
        setActiveMenuItem(index === activeMenuItem ? null : index);
        const menuItemRect = event.target.getBoundingClientRect();
        setSubmenuPosition({
            top: menuItemRect.top - 100,
            left: menuItemRect.right - 20,
        });
        navigatePage(item.cardData[0].data.onTap);
    };

    const removeQueryParam = (url, param) => {
        const urlObj = new URL(url, window.location.origin); // Create a URL object
        urlObj.searchParams.delete(param); // Remove the parameter
        return urlObj.search; // Return the new query string
    };
    const navigatePage = (data) => {
        if (data.NavigationType === "3") {
            const currentPath = window.location.pathname; // Current page path
            const currentQueryParams = window.location.search;
    
            let newQueryParams = removeQueryParam(currentQueryParams, "type");
            newQueryParams = removeQueryParam(newQueryParams, "typeId");
            newQueryParams = removeQueryParam(newQueryParams, "pageId");
    
            let targetUrl = ""; // Initialize the target URL
            let targetPath = ""; // Path without query params
    
            if (data.FSN === 103) {
                targetUrl = `/store_home_page${newQueryParams}&productId=${data.FAI.productId}`;
                targetPath = "/store_home_page";
            } else if (data.FSN === 120) {
                targetUrl = `/address${newQueryParams}&type=${data.FAI.type}&typeId=${data.FAI.typeId}`;
                targetPath = "/address";
            } else if (data.FSN === 200) {
                targetUrl = `/store_order_details${newQueryParams}`;
                targetPath = "/store_order_details";
            } else if (data.FSN === 170) {
                targetUrl = `/fsn170${newQueryParams}`;
                targetPath = "/fsn170";
            }
    
            // Check if the current path matches the target path
            if (currentPath !== targetPath) {
                window.location.href = targetUrl; // Navigate only if the target path is different
            } else {
                console.log("You are already on the target page:", targetPath);
                setIsMenuVisible(false);
            }
        }
    };
    const toggleMenuVisibility = () => {
        setActiveMenuItem(null);
        setIsMenuVisible(!isMenuVisible);
    };

    return (
        <div>
            {/* Menu Icon */}
            <div
                style={{
                    height: "24px",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "inline-block",
                }}
                onClick={toggleMenuVisibility}
            >
                {/* <img height="24px" src="https://appcdn.goqii.com/storeimg/88678_1733389747.webp" /> */}
                <MenuIcon style={{ fontSize: "22px", color: "#681517", marginBottom: "5px" }} />
            </div>

            {/* Main Menu */}
            {isMenuVisible && (
                <div
                    style={{
                        position: "absolute",
                        top: "3rem",
                        left: "1rem",
                        backgroundColor: "#FFE9E9",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        padding: "1rem",
                        zIndex: 1000,
                        width: "180px",
                        fontSize: "10px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <ul
                        style={{
                            listStyleType: "none",
                            margin: 0,
                            padding: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                        }}
                    >
                        {menuItems.map((item, index) => {
                            const IconComponent = item.cardData[0].data.Icon;
                            return (
                                <li
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        padding: "0.75rem",
                                        backgroundColor: "#FF7B7C",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        textAlign: "left",
                                        position: "relative",
                                    }}
                                    onClick={(e) => handleMenuItemClick(index, e, item)}
                                >
                                    <IconComponent
                                        style={{
                                            fontSize: "20px",
                                            flexShrink: 0,
                                        }}
                                    />
                                    <span style={{ flexGrow: 1 }}>{item.cardData[0].data.itemName}</span>
                                    {activeMenuItem === index && item.cardData[0].data.subCategories && (
                                        <SubMenu
                                            subMenuList={item.cardData[0].data.subCategories}
                                            position={submenuPosition}
                                            toggleMenuVisibility={toggleMenuVisibility}
                                        />
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default MainMenu;